import React from 'react';
import { motion } from 'framer-motion';
import { Timer } from 'lucide-react';
export function UrgencyBar() {
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="sticky top-0 z-50 w-full bg-brand-accent text-brand-dark px-4 py-3 shadow-lg" data-id="element-123">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left" data-id="element-124">
        <div className="flex items-center gap-2 font-semibold text-sm sm:text-base" data-id="element-125">
          <span className="animate-pulse" data-id="element-126">🔥</span>
          <p data-id="element-127">
            ACCESO INMEDIATO: Consigue el método completo por solo $11.36.
            Oferta por tiempo limitado.
          </p>
        </div>
        <a href="#cta" className="hidden sm:flex items-center gap-1 bg-brand-dark text-brand-accent px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider hover:bg-black transition-colors" data-id="element-128">
          <Timer className="w-3 h-3" data-id="element-129" />
          Obtener ahora
        </a>
      </div>
    </motion.div>;
}